import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-select-camera-mode-type',
  templateUrl: './select-camera-mode-type.component.html',
  styleUrls: ['./select-camera-mode-type.component.scss']
})
export class SelectCameraModeTypeComponent implements OnInit {
  modalRef: NgbModalRef;
  closeResult: string;

  showCamera: boolean = false;
  isMultiMode: boolean = false;

  constructor(
    private modalService: NgbModal
  ) { }

  ngOnInit() {
  }

  @ViewChild("selectMode") private selectMode: ElementRef;


  open() {
    this.modalRef = this.modalService.open(this.selectMode);
    this.modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/select-camera-mode-type/select-camera-mode-type.component.ts